import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=5f05afd0&scoped=true"
import script from "./search-bar.vue?vue&type=script&lang=js"
export * from "./search-bar.vue?vue&type=script&lang=js"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=5f05afd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f05afd0",
  null
  
)

export default component.exports